/* global isUserAuthenticated, isSubagent, isUnfinishedReservation, prettyPhotoOptions, unitsCapacity, unavailDates */
/* global unitsWithPets, unitsData, getFormValuesUrlJSON, defaultFormValues, stepMax, oldGuestDiscount1 */
/* global oldGuestDiscount2, oldGuestDiscount3, reservationUrl, isInline, getUnavailDatesUrlJSON, calculationUrlTable */
/* global privateObjectId, isOurSiteUser, isAdriaticOffice, bookingConditionsErr, service, preCheck, userInfoUrl */
/* global subagentUserRegisterUrl, userRegisterUrl, userUpdateProfileUrl, setGaqPush, Ad, processStartedUrl */
/* global calculationUrlJSON, unfinishedReservationUrlJSON, userAgreementsStatusUrl, isReservationOffer */
import { registerPrivateAccommodationReservationPriceCalculated as dataLayerRegisterPrivateAccommodationReservationPriceCalculated }
    from '@PROJECT_ROOT/assets/shared/js/dataLayer';
 import { v4 as uuidv4 } from 'uuid';

var previousRequestType = (window.local_vac_html == undefined) ? 'GET' : 'POST'; // local_vac_html - is HTML service
var fadeInAndOutTime = 350;
var previousRequest;
var userSelectedBookingInsuranceVal = false;
var userSelectedBookingInsuranceOption = false;
var userSelectedWeatherInsurance = false;
var userSelectedWeatherInsuranceValue = false;
var isUserSignedIn = (typeof isUserAuthenticated === 'undefined' ? false : isUserAuthenticated);
var userRadioChoice;
var doesUserHaveConsent = false;
var isUserSubscribedToNewsletter = false;
var isFormPopulated = false;
let step = window.step === undefined ? 1 : window.step;

// Metoda radi samo na rezervacijskoj formi /hr/reservation/private?object=1005
function addUnit() {
    var $hiddenUnits = $('.unitHidden');
    var $allUnits = $('.unitRow');

    if ($hiddenUnits.length) {
        $hiddenUnits.first().removeClass('unitHidden');

        if ($('.unitHidden').length === 0) {
            $('.addUnit').hide();
        }

        $allUnits.each(function() {
            var $self = $(this);

            if (!$self.hasClass('unitHidden') && $self.find('select').val()) {
                $self.insertBefore($self.prev());
                $self.find('.personsNumbersWrap').show();
            } else {
                $self.find('.personsNumbersWrap').hide();
            }
        });

        refreshPersonNumber();
    }
}

// Metoda radi samo na rezervacijskoj formi /hr/reservation/private?object=1005
function removeUnit($target) {
    var $unitHolder = $target.parent();
    var $unitSelect = $unitHolder.find('.unitSelectWrap select');
    var wasUnitSelected = $unitSelect.val() !== '';

    $unitSelect.val('');
    $unitHolder.addClass('unitHidden');

    if ($('.unitHidden').length >= 1) {
        $('.addUnit').show();
    }

    if (wasUnitSelected) {
        refreshCalculation();
    }
}

function refreshPersonNumber() {
    var selectedUnitsNum = 0;

    $('.unit-persons').hide();
    $("select[id$=_selected] option").prop('disabled', false);

    if ($('.unitHidden').length === 0) {
        $('.addUnit').hide();
    }

    $("select[id$=_selected]").each(function () {
        var self = $(this);
        let unitId;

        if (self.val()) {
            unitId = self.val();
            $("select[id$=_selected]").each(function () {
                if ($(this).attr('id') !== self.attr('id')) {
                    $(this).find("option[value="+self.val()+"]").prop('disabled', true);
                }
            });
        }

        if (!self.parents('.unitHidden').length && self.val() && !self.prop('disabled')) {
            selectedUnitsNum++;
            self.parents('.unitRow').find('.unit-persons').show();

            var unitPersonsRow = self.parents('.unitRow').first();

            if (unitsCapacity) {
                editUnitPersonsSelectors(unitPersonsRow, unitsCapacity[unitId] );
            }

            $(this).parents('.unitRow').find('.personsNumbersWrap').show();
        }
    });

    if (selectedUnitsNum < 2) {
        $('.unit-persons').hide();
        $('.unit-persons').find('select').prop('disabled', true);
    }
    intervalChange(true,true);
}

function editUnitPersonsSelectors(unitPersonsRow, unitCapacity) {
    var personsCategory = ['a1', 'c1', 'c2', 'c3'];

    jQuery.each(personsCategory, function(ind, perCat) {
        var personsSelectOptions = [];
        const unitPersonCategoryCapacity = unitCapacity[perCat];
        for (var i = 0; i <= unitPersonCategoryCapacity; i++) {
            personsSelectOptions.push({ text: i, value: i});
        }
        unitPersonsRow.find('select[id$="_'+perCat+'"]').each(function () {
            var selectedValue = $(this).val();
            $(this).replaceOptions(personsSelectOptions);
            if (selectedValue !== null && selectedValue <= unitPersonCategoryCapacity) {
                $(this).val(selectedValue);
            }
        });
    });
}

function beforeShowDayFromSelect(dt) {
    return beforeShowDaySelect(dt, 'from');
}

function beforeShowDayToSelect(dt) {
    return beforeShowDaySelect(dt, 'to');
}

function beforeShowDaySelect(dt, fromTo) {
    var cssClass = '', selectedCssClass = '';
    var isoDate = $.datepicker.formatDate('yy-mm-dd', dt);
    var time = dt.getTime();
    var dateFrom = $('#R_i_from_visual').datepicker('getDate');
    var dateTo = $('#R_i_to_visual').datepicker('getDate');

    if (dateFrom && time == dateFrom.getTime()) {
        selectedCssClass = 'unavail_temp_start';
    }

    if (dateTo && time == dateTo.getTime()) {
        selectedCssClass = 'unavail_temp_end';
    }

    if (dateFrom && dateTo && time > dateFrom.getTime() && time < dateTo.getTime()) {
        selectedCssClass = 'unavail_temp';
    }

    $("select[id^=R_u_]").each(function () {
        var unitId = $(this).val();

        if (unavailDates[unitId] !== undefined && unavailDates[unitId][isoDate] !== undefined) {
            var newCssClass = unavailDates[unitId][isoDate];

            if (cssClass == '') {
                cssClass = newCssClass;
            }

            if (newCssClass == 'unavail') {
                cssClass = newCssClass;
            } else if (cssClass == 'unavail_start' && newCssClass == 'unavail_end') {
                cssClass = 'unavail';
            } else if (newCssClass == 'unavail_start' && cssClass == 'unavail_end') {
                cssClass = 'unavail';
            } else if (cssClass == 'preferred_start' && newCssClass == 'preferred_end') {
                cssClass = 'preferred';
            } else if (newCssClass == 'preferred_start' && cssClass == 'preferred_end') {
                cssClass = 'preferred';
            } else if (newCssClass == 'preferred_start' && cssClass == 'preferred_start') {
                cssClass = 'preferred';
            }
        }
    });

    let enableDay;
    if (fromTo == 'from') {
        if (cssClass == 'preferred' ||
            cssClass == 'preferred_start' ||
            cssClass == 'preferred unavail_end' ||
            cssClass == 'unavail_end preferred' ||
            cssClass == 'preferred unavail_temp_end' ||
            cssClass == 'unavail_temp_end preferred'
        ) {
            enableDay = true;
        } else {
            enableDay = false;
        }
    } else {
        if (cssClass == 'preferred' ||
            cssClass == 'preferred_end' ||
            cssClass == 'preferred unavail_start' ||
            cssClass == 'preferred unavail_temp_start' ||
            cssClass == 'available unavail_start' ||
            cssClass == 'available unavail_temp_start'
        ) {
            enableDay = true;
        } else {
            enableDay = false;
        }
    }

    if ((cssClass == 'unavail_end' || cssClass == 'unavail' || cssClass == 'unavail_end preferred') && selectedCssClass == 'unavail_temp_start') {
        cssClass = 'unavail_cross_temp';
    } else if ((cssClass == 'unavail_start' || cssClass == 'unavail' || cssClass == 'preferred unavail_start') && selectedCssClass == 'unavail_temp_end') {
        cssClass = 'temp_cross_unavail';
        enableDay = true;
    } else if (selectedCssClass != '') {
        cssClass = selectedCssClass;
    }

    if (enableDay === false) {
        cssClass = cssClass + " specificDates";
    }

    return [enableDay, cssClass];
}

function intervalChange(skipRefreshPerson, skipRefreshCalculation) {
    var displayMessage = false;

    var dateFrom = $('#R_i_from_visual').datepicker('getDate');
    var dateTo = $('#R_i_to_visual').datepicker('getDate');
    var showPets = true;
    var showPetsDescription = true;
    var selectedUnits = [];
    var atLeastOneUnitAvailable = false;

    $("span[id^=unitUnavailable]").hide();

    // paziti da se ne selektiraju i persons, jer pocinju s istim komadom stringa
    $("select[id^=R_u_][id$=_selected]").each(function () {
        var unitId = $(this).val();
        if ($.isNumeric(unitId)) {
            selectedUnits.push(unitId);
        }

        var selectId = $(this).attr('id').replace(/[a-zA-Z-_]/g, '');
        var unitAvailable = true;

        if (!unitsWithPets[unitId]) {
            showPets = false;
        }

        if (unavailDates[unitId] !== undefined) {
            if (dateFrom && dateTo) {
                $.each(unavailDates[unitId], function (unavailDate, unavailType) {
                    unavailDate = $.datepicker.parseDate('yy-mm-dd', unavailDate);

                    if ((unavailDate > dateFrom && unavailDate < dateTo) || (unavailDate == dateFrom && unavailType == 'unavail_start')) {
                        unitAvailable = false;
                        $('#unitUnavailable' + selectId).show();
                        displayMessage = true;
                        return true; // continue
                    }
                });
                if (unitAvailable) {
                    atLeastOneUnitAvailable = true;
                }
            }
        }
    });

    var petUnitsAllow = [];
    var petUnitsForbidden = [];

    jQuery.each(selectedUnits, function(index, unitId){
        if (unitsData[unitId].pet) {
            petUnitsAllow.push(unitId);
        } else {
            petUnitsForbidden.push(unitId);
        }
    });

    if (selectedUnits.length > 0 && petUnitsAllow.length > 0) {
        //prikazi polje za odabir broja kucnih ljubimaca
        $('#R_pet').parent().show();

        //ako je broj ljubimaca postavljen prikazi polje za opis ljubimaca
        if ($('#R_pet').val() > 0) {
            $('.petDescription').show();
        } else {
            $('.petDescription').hide();
        }

        //sakri poruku o ne drzanju kucnih ljubimaca
        $('#noPetMessage').hide();

    } else {
        //prikazi poruku o nedozvoljem drzanju kucnih ljubimaca i sakri polja za unos informacija o kucnim ljubimcima
        $('#R_pet').parent().hide();
        $('#R_pet').val(0);
        $('#R_pet_desc').val('');
        $('.petDescription').hide();
        $('#noPetMessage').show();
    }

    $("#petAcceptanceInfoMessage").hide();
    $("#petAcceptanceInfoMessage>.forbiddenUnits").hide();

    if (petUnitsForbidden.length > 0 && petUnitsForbidden.length < selectedUnits.length) {
        //ako su zabranjenji ljubimci u barem jednoj jedinici ali ne u svima
        $('#noPetMessage').hide();
        $("#petAcceptanceInfoMessage").show();
        $("#petAcceptanceInfoMessage>.forbiddenUnits").show();
        $("#petAcceptanceInfoMessage>.forbiddenUnits>span.unitsList").show();

        var units = [];

        for (var i = 0; i < petUnitsForbidden.length; i++) {
            units.push(unitsData[petUnitsForbidden[i]].code);
        }

        $("#petAcceptanceInfoMessage>.forbiddenUnits>span.unitsList").html(units.join(', '));
    } else if (petUnitsForbidden.length == selectedUnits.length) {
        //ako nije dopusteno drzanje kucnih ljubimaca niti u jednoj jedinici
        $('#R_pet_desc').val('');
        $('#R_pet').val(0);
        $("#petAcceptanceInfoMessage>.forbiddenUnits").hide();
        $('#noPetMessage').show();
    }

    if (petUnitsAllow.length == 0) {
        $('#R_pet').parent().hide();
        $('#R_pet').val(0);
    }

    if (skipRefreshPerson === undefined) {
        refreshPersonNumber();
    } else if (skipRefreshCalculation === undefined) {
        refreshCalculation();
    }
}

function guestTypeChange() {
    var guestType = $('#R_g_type').val();
    $('.returningGuestRow, .recommendingRow').hide();

    if (guestType == 'g_old') {
        $('.returningGuestRow').show();
    } else if (guestType == 'recomm') {
        $('.recommendingRow').show();
    }
}

const canUseSyncXHR = !document.featurePolicy || document.featurePolicy.allowsFeature('sync-xhr');
var falsSync = canUseSyncXHR ? false : true;
function populateFormDataValues() {
    window.requestList.pReservation = $.ajax({
        type: 'POST',
        url: getFormValuesUrlJSON,
        dataType: 'json',
        data: defaultFormValues,
        async: falsSync,
        success: function fillForm(response) {
            if (response.unavail_dates !== undefined) {
                unavailDates = response.unavail_dates;
            }
            if (response.defaults !== undefined) {
                if (response.defaults.i_from !== undefined && response.defaults.i_from != 'NaN-NaN-NaN') {
                    $('#R_i_from_visual').datepicker('setDate', parseDate(response.defaults.i_from)).datepicker('refresh');
                }

                if (response.defaults.i_to !== undefined && response.defaults.i_to != 'NaN-NaN-NaN') {
                    $('#R_i_to_visual').datepicker('setDate', parseDate(response.defaults.i_to)).datepicker('refresh');
                }

                if (response.defaults.u !== undefined) {
                    jQuery.each(response.defaults.u, (i, unitData) => {
                        const unitSelector = `#R_u_${i}_`;
                        if (unitData.selected !== null) {
                            if ((window.location.hash && window.location.hash === '#resWrap')
                                || isUnfinishedReservation
                                || isReservationOffer
                            ) {
                                // Odabrane jedinice čuvamo samo za nedovršenu rezervaciju i Facebook/Google prijavu #34098
                                $(`${unitSelector}selected option`).each(function setSelectedUnitId() {
                                    // šetamo po svakoj opciji u dropdownu s jedinicama
                                    if (unitData.selected.toString() === $(this).val()) {
                                            // ako je jedinica ponuđena vrijednost u dropdownu, postavlja se kao odabrana
                                            if (i > 0) {
                                                // dodaje dropdown element ako se može popuniti više jedinica,
                                                // npr. kod nedovršene rezervacije
                                                addUnit();
                                            }
                                            $(`${unitSelector}selected`).val(unitData.selected);
                                        }
                                    }
                                );
                            }
                        }
                        if (unitData.selected.toString() === $(`${unitSelector}selected`).val()) {
                            if (unitData.a1 > 0) {
                                $(`${unitSelector}a1`).val(unitData.a1.toString());
                            }
                            if (unitData.c1 > 0) {
                                $(`${unitSelector}c1`).val(unitData.c1.toString());
                            }
                            if (unitData.c2 > 0) {
                                $(`${unitSelector}c2`).val(unitData.c2.toString());
                            }
                            if (unitData.c3 > 0) {
                                $(`${unitSelector}c3`).val(unitData.c3.toString());
                            }
                        } else {
                            if (response.defaults.a1 != undefined) {
                                $(`${unitSelector}a1`).val(response.defaults.a1.toString());
                            }
                        }
                    });
                } else if (response.defaults.a1 != undefined && response.defaults.a1 > 0) {
                    $('#R_u_0_a1').val(response.defaults.a1.toString());
                }

                if (response.defaults.food !== undefined) {
                    $('#R_food').val(response.defaults.food);
                }

                if (response.defaults.p_type !== undefined) {
                    $('#R_p_type').val(response.defaults.p_type);
                }

                if (response.defaults.pet !== undefined && response.defaults.pet_desc !== undefined) {
                    $('#R_pet').val(response.defaults.pet);
                    $('#R_pet_desc').val(response.defaults.pet_desc);
                }

                if (response.defaults.weather_insurance !== undefined
                    && response.defaults.weather_insurance_type !== undefined
                ) {
                    $('#R_weather_insurance').val(response.defaults.weather_insurance);
                    $(`#R_weather_insurance_type_${response.defaults.weather_insurance_type}`).prop('checked', true);
                }

                if (response.defaults.user_register !== undefined
                    && response.defaults.user_register.recommending_code !== undefined) {
                    $('#R_user_register_recommending_code').val(response.defaults.user_register.recommending_code);
                }

                if (response.defaults.remarks !== undefined) {
                    $('#R_remarks').val(response.defaults.remarks);
                }

                isFormPopulated = true;
            }
            persistMultipleSelectedUnits(response.defaults.u);
            refreshPersonNumber();
        }
    });
}

function persistMultipleSelectedUnits(unitsData) {
    var unitsCount = 0;
    var preparedUnitsData = new Array();
    var continueWithSelection = false;
    for (var prop in unitsData) {
        var objectData = new Object();
        objectData.unitId = parseInt(prop, 10);
        objectData.selectedPersons = unitsData[prop];
        preparedUnitsData[unitsCount] = objectData;
        unitsCount++;
    }

    if (unitsCount > 1) {
        var unitsSelectElements = $(".unitRow").add(".unitRow:hidden");
        var counter = 0;
        unitsSelectElements.first().find('select[id*="_selected"]').find("option").each(function () {
            for (var key in preparedUnitsData) {
                if (preparedUnitsData[key].unitId == parseInt($(this).val(), 10)) {
                    continueWithSelection = true;
                }
            }
        });
        if (continueWithSelection) {
            unitsSelectElements.each(function () {
                if (counter < unitsCount) {
                    var unitId = preparedUnitsData[counter].unitId;
                    $(this).find('select[id*="_selected"]').find("option[value="+unitId+"]").prop('disabled', false);
                    $(this).find('select[id*="_selected"]').val(preparedUnitsData[counter].unitId).prop('disabled', false);
                    $(this).find('select[id*="_persons"]').val(preparedUnitsData[counter].selectedPersons).prop('disabled', false);
                    $(this).find('.unit-persons').show();
                    $(this).removeClass('unitHidden');
                }
                counter++;
            });
        }
    }
}

function refreshCalculation(isNotInlineAsync, initialCalculation) {
    $('.reservationLoader').fadeIn(fadeInAndOutTime);

    // Skriti botun tokom refresh animacije
    $('#addUnitBtn').hide();

    if (!isFormPopulated) {
        // ako forma nije popunjena, znači da se dogodilo nešto(npr izbor druge jedinice) zbog čega treba resetirati
        // step na početak
        changeStep(1, true);
        populateFormDataValues();
    }

    var returnValue = false;

    let isAsync;
    if (isNotInlineAsync == undefined) {
        isAsync = true;
    } else {
        isAsync = isNotInlineAsync;
    }

    var postData = $('#R').serialize();

    if (window.requestList.pReservation && window.requestList.pReservation.readyState != 4) {
        if (canUseSyncXHR) {
            window.requestList.pReservation.abort();
        }
        $(".reservationLoader").fadeIn(fadeInAndOutTime);
    }

    if (step == 1) {
        $("[data-nextstep=2]").removeClass('green').addClass('gray');
    }

    if (step == 2) {
        changeCountry();
    }

    if (step == 3) {
        const unitSelects = document.querySelectorAll('[name^="R[u]"][name$="[selected]"]');
        const selectedUnitIds = [];
        unitSelects.forEach((unitSelect) => {
            if (unitSelect.value !== '') {
                selectedUnitIds.push(unitSelect.value);
            }
        });
        $.ajax({
            url: processStartedUrl,
            type: 'POST',
            data: { userEmail: $('#R_user_register_email').val(), unitIds: selectedUnitIds },
        });
    }

    var isAsync2 = canUseSyncXHR ? isAsync : true;
    window.requestList.pReservation = $.ajax({
        url: calculationUrlJSON,
        async: isAsync2,
        type: 'POST',
        data: postData,
        cache: false,
        success: function(response) {
            $("input[id^=R_insurance_type_]").parents("li").hide();
            $("#bookingInsuranceHolder, .insuranceTypeRow").hide();
            $("#advancePaymentDate, #restPaymentDate, #priceWithoutDiscountWrapper, #discountValueWrapper, #restPaymentWrapper, .advancePaymentWrapper, .calculationDetails, .paymentIcons").hide();

            if ($('#paymentMethodMessage').length > 0) {
                $('#paymentMethodMessage').hide();
            }

            if (step == 1 && $('#unitUnavailableMessage').css('display') != 'block') {
                if (response.status == 'success' || stepMax > step) {
                    if ($('#R_p_type').length < 1 || $('#R_p_type').val()) {
                        $('[data-nextstep=2]').removeClass('gray').addClass('green');
                    }
                }
            }

            var freeOrderCancellation = response.freeOrderCancellation;

            if (response.status == 'session_expired') {
                $('.reservationLoader').hide();
                returnValue = false;
            } else if (response.status == 'error') {
                createErrorMessagesList(response.data);
                $('.reservationTotalPrice').html('?');
                if ($('#R_p_type').length > 0) {
                    $('#paymentMethodMessage').hide();
                }
                $('[data-nextstep=2]').removeClass('green').addClass('gray');
                returnValue = false;
                changeFreeOrderCancellationPolicy(freeOrderCancellation);

                if (response.availableDatesWithDeviation) {
                    $('.calculationMessages').append(response.availableDatesWithDeviation);

                    $('.dateWithDeviation').on('click', function() {
                        const from = $(this).data('from');
                        const to = $(this).data('to');

                        if (from && to) {
                            $("#R_i_from_visual").datepicker('setDate',  parseDate(from)).datepicker("refresh");
                            $("#R_i_to_visual").datepicker('setDate',  parseDate(to)).datepicker("refresh");

                            refreshCalculation();
                        }
                    });
                }
            } else {
                returnValue = true;
                var data = response.data;

                $('.calculationDetails, .paymentIcons').show();

                if (step != 3) {
                    $('.calculationMessages').empty();
                }

                if (step == 2) {
                    if (data.user && data.profile_modified) { // Ako je user logiran i vec je izmjenio profil
                        //changeStep(2,true);
                    } else if ($('.userNextStep').length > 0) {
                        $('.userNextStep').fadeIn(fadeInAndOutTime);
                    }
                }

                $('.reservationTotalPrice').data('rawprice', data.total_price_raw).html(data.total_price);

                if (data.total_price_no_discount !== null) {
                    $('#priceWithoutDiscount').html(data.total_price_no_discount);
                }

                if (data.discount !== null) {
                    $('#discountValue').html(data.discount);
                }

                if (data.advance_payment !== null) {
                    $('.reservationAdvancePaymentPrice').html(data.advance_payment);
                }

                if (data.rest_payment !== null) {
                    $('#restPayment').html(data.rest_payment);
                }

                if (data.rest_payment_type !== null && $('.restPaymentType').length > 0) {
                    $('.restPaymentType').text(data.rest_payment_type);
                }

                if (data.payment_dates) {
                    if (data.payment_dates.advance) {
                        $('#advancePaymentDate').html('(' + data.payment_dates.advance + ')').show();
                    }

                    if (data.payment_dates.rest) {
                        $('#restPaymentDate').html('(' + data.payment_dates.rest + ')').show();
                    }
                }

                // Poruka o financijskoj obavezi se ne pokazuje za Online Booking
                $('.privateSendRequestNote, .privateSendRequestNoteMarker').toggle(!data.online_booking);

                $('#priceWithoutDiscountWrapper').toggle(data.total_price_no_discount !== null);
                $('#discountValueWrapper').toggle(data.discount !== null);
                $('.advancePaymentWrapper').toggle(data.advance_payment !== null);
                $('#restPaymentWrapper').toggle(data.rest_payment !== null);

                if ($('#R_p_type').length > 0) {
                    $('#paymentMethodMessage').toggle($('#R_p_type').val() == '');
                }

                if (data.old_guest.count !== undefined && data.old_guest.services != 'generic') {
                    var oldGuestServicesLabelHolder = $('#oldGuestServicesLabel');
                    $('#R_g_type').val('g_old').hide();
                    if (!oldGuestServicesLabelHolder.is(':visible')) {
                        if (data.old_guest.count == 1) {
                            oldGuestServicesLabelHolder.html(oldGuestDiscount1);
                        } else if (data.old_guest.count == 2) {
                            oldGuestServicesLabelHolder.html(oldGuestDiscount2);
                        } else if (data.old_guest.count >= 3) {
                            oldGuestServicesLabelHolder.html(oldGuestDiscount3);
                        }

                        $(".recommendingRow").hide();
                        oldGuestServicesLabelHolder.fadeIn(fadeInAndOutTime);
                    }
                }

                $("input[id^=R_insurance_type_]").each(function () {
                    if ($(this).is(":checked")) {
                        userSelectedBookingInsuranceVal = $(this).val();
                        return;
                    }
                });

                if (data.insurance !== undefined && data.insurance.length !== 0) {
                    $.each(data.insurance, function(id, value){
                        var label = $('label[for=R_insurance_type_'+ id +']');
                        var price = ' (' + value + ')';
                        var container = label.find('.insuranceAmount');

                        if (container.length > 0) {
                            container.html(price);
                        } else {
                            label.append('<span class="insuranceAmount">' + price + '</span>');
                        }

                        label.parents('li').show();
                    });
                    //precheckiranje osiguranja od otkaza putovanja
                    var isChecked = $("input[id^=R_insurance_type_]").is(':checked');

                    if (!isChecked || (isChecked && userRadioChoice == false)) {
                        $.each(data.insurance, function(id){
                            $("#R_insurance_type_"+ id).prop('checked', true);
                            return false;
                        });
                    }

                    $('#bookingInsuranceHolder').show();
                    $('.insuranceTypeRow').toggle($('#R_insurance').prop('checked'));

                    if (userSelectedBookingInsuranceVal && userSelectedBookingInsuranceOption) {
                        $("input[id=R_insurance_type_" + userSelectedBookingInsuranceVal + "]").prop('checked',true);
                        $('#R_insurance').prop('checked',true);
                        $(".insuranceTypeRow").show();
                    }

                } else {
                    $('#bookingInsuranceHolder').hide();
                }

                if ((data.weatherinsurance !== undefined) && (data.weatherinsurance != null)) {
                    if (data.weatherinsurance.length !== 0) {
                        $('#weather_insurance ul li').each(function () {
                            $(this).find('span').remove();
                        });

                        if (data.is_our_site_user) {
                            $("label[for=R_weather_insurance_type_69]").append('<span class="insuranceAmount">&nbsp;(GRATIS)</span>');
                            $("label[for=R_weather_insurance_type_70]").append('<span class="insuranceAmount">&nbsp;(' + data.weatherinsurance[100] + ')</span>');
                            if (
                                !$('#R_weather_insurance_type_69').prop('checked') &&
                                !$('#R_weather_insurance_type_70').prop('checked')
                            ) {
                                $('#R_weather_insurance').prop('checked', true);
                                $('#R_weather_insurance_type_69').prop('checked', true);
                            }
                        } else {
                            $("label[for=R_weather_insurance_type_69]").append('<span class="insuranceAmount">&nbsp;(' + data.weatherinsurance[50] + ')</span>');
                            $("label[for=R_weather_insurance_type_70]").append('<span class="insuranceAmount">&nbsp;(' + data.weatherinsurance[100] + ')</span>');
                        }

                        $("#weatherInsuranceHolder").fadeIn(fadeInAndOutTime);
                        if ($("#R_weather_insurance").is(':checked')) {
                            $("#weather_insurance").fadeIn(fadeInAndOutTime);
                        }
                    }
                } else {
                    $("#weatherInsuranceHolder").hide();
                    $("#R_weather_insurance, #R_weather_insurance_type_69, #R_weather_insurance_type_70").prop("checked",false);
                }

                // Inline data
                if ($('.reservationUnitsList').length > 0) {
                    $('.reservationUnitsList').empty();
                    if (data.u) {
                        $.each(data.u, function(id, unitName){
                            $('.reservationUnitsList').append($('<li />').text(unitName));
                        });
                    }
                }

                if (data.show_transfer) {
                    $('#transferHolder').show();
                }

                if ($('.reservationInterval').length > 0) {
                    $('.reservationInterval').text(data.interval[0] + ' - ' + data.interval[1]);
                }

                if ($('.reservationUser').length > 0) {
                    $('.reservationUser').hide();

                    if (data.user) {
                        $('.reservationUser .name').html(data.user.name);
                        $('.reservationUser .email').html(data.r_user.email);

                        if (data.user.phone) {
                            $('.reservationUser .reservationPhone').html('(' + data.user.phone + ')');
                        } else {
                            $('.reservationUser .reservationPhone').empty();
                        }

                        if (step == 2) {
                            $("#editUserLink").hide();
                        } else {
                            $("#editUserLink").show();
                        }

                        if (step == 2) {
                            $('.reservationUser').hide();
                        } else {
                            $('.reservationUser').show();
                        }
                    }
                }

                if (data.r_user) {
                    if (null !== data.emailFieldValue) {
                        fillRegisteredUserData(data.r_user, data.emailFieldValue);
                    } else {
                        fillRegisteredUserData(data.r_user);
                    }

                    $("#userNotAuthenticated").hide(fadeInAndOutTime);
                    $("#userAuthenticatedEmail").html(data.r_user.email);
                    $("#secondStepNotification").show();
                }

                if (data.userSignInSignOut) {
                    $('#userSignInSignOut').html(data.userSignInSignOut).show();
                }

                changeStepForSocialLogin(data.profile_modified, data.api_login_time);
                changeFreeOrderCancellationPolicy(freeOrderCancellation);
            }

            if (response.hasConsent) {
                $('#consent_checkbox').hide();
            } else {
                $('#consent_checkbox').show();
            }

            if (response.isUserSubscribedToNewsletter) {
                $('.newsletterCheckbox').hide();
            } else {
                $('.newsletterCheckbox').show();
            }

            if (step == 2) {
                $('.paymentIcons').hide();
                $('.calculationDetails').hide();
            }
        },
        complete: function(xhr, status){
            if (status == 'error') {
                returnValue = false;
                if ($('#inlineReservation').length > 0) {
                    window.requestList.pReservation = $.ajax({
                        url: reservationUrl,
                        success: function(data) {
                            $('#inlineReservation').html(data);
                        }
                    });
                }
                $('.reservationLoader').fadeOut(fadeInAndOutTime);
            } else {
                $('.reservationLoader').fadeOut(fadeInAndOutTime);
                returnValue = true;
            }

            if (step === 1 && $('.unitHidden').length > 0) {
                // Prikazati botun nakon refresh animacije
                $('#addUnitBtn').show();
            }
        },
        error: function(xhr, status){
            $('.reservationLoader').hide();
            returnValue = false;
        }
    });

    window.requestList.pReservation.success(() => reportUnfinishedReservation());

    window.requestList.pReservation.success((response) => updateDataLayerAfterCalculationRefresh(response, initialCalculation));

    return returnValue;
}

function changeFreeOrderCancellationPolicy(freeOrderCancellation) {
    $('.orderCancelationPolicy').html(freeOrderCancellation);
}

function singleInit(options) {
    if (window.requestList.pReservation && window.requestList.pReservation.readyState != 4) {
        if (canUseSyncXHR) {
            window.requestList.pReservation.abort();
        }
    }

    isFormPopulated = false;
    userRadioChoice = false;
    var newsletterCheckbox = $("#R_user_register_newsletter");
    var preventDoubleSubmit = false;

    // Polja koja imaju utjecaj na kalkulaciju
    var triggerCalculation = "#R_a1, #R_c1, #R_c2, #R_c3, #R_pet, select[id$=_persons]," +
    "#R_food, input[id^=R_insurance_type_], #R_g_type, select[id^=R_g_srvc]," +
    "#R_g_srvc_num, select[id=R_p_type], input[id^=R_weather_insurance_type_], input[id^=R_weather_insurance], select[id^=R_u_]";

    if (!isInline) {
        triggerCalculation = triggerCalculation + ", #R_user_register_email";
    }

    var triggerCalculationKeyUp = "#R_recomm_g, #R_recomm_camp, #R_g_srvcs";

    var delayKeyUp = ( function() {
        var timer = 0;
        return function(callback, ms){
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        };
    })();

    // GA eventovi - https://home/projects/planning/wiki/Google_Analytics_eventi
    if (isInline && !isSubagent) {
        $('#R').on('click', '.calculationDetails', function() {
            setGaqPush('Detaljna kalkulacija', step + '. korak inline', '', '');
        });
    }

    $('#R').on('click', '.loginFacebook', function() {
        setGaqPush('Prijava', 'Facebook', 'Inline forma', '');
    });

    $('#R').on('click', '.loginGoogle', function() {
        setGaqPush('Prijava', 'Google', 'Inline forma', '');
    });

    $('#R').on('click', '#loginButton', function() {
        setGaqPush('Prijava', 'Adriatic', 'Inline forma', '');
    });

    $('#R').on('click', '.reservationTabs', function() {
        var $self = $(this);

        const $element = $('#R_u_type_' + $self.data('tab'));
        changeUserType($element);

        $('.reservationTabs.active').removeClass('active');
        $self.addClass('active');
    });

    // Prenošenje unesenog emaila u formu za zaboravljenu lozinku
    // Omogućeno samo za naš site radi različitih URLova na affiliate servisima i jer na subagent servisima forma
    // ne sadrži link na zaboravljenu lozinku
    if (isOurSiteUser) {
        const forgetPasswordLink = document.getElementById('forgetPassword');
        if (null !== forgetPasswordLink) {
            forgetPasswordLink.addEventListener('click', (event) => {
                let url = event.currentTarget.href;
                url += url.indexOf('?') > -1 ? '&' : '?';
                url += `email=${document.getElementById('R_user_login_username').value}`;
                forgetPasswordLink.href = url;
            });
        }
    }

    $('#R').on('click', '.previousStep', function() {
        changeStep(step - 1, true);
        return false;
    });

    $("input[id^=R_insurance_type_]").click(function () {
        userRadioChoice = true;
    });

    Ad.Datepicker.initRange(
        '#R_i_from',
        '#R_i_to',
        {
            'beforeShowDayFrom': beforeShowDayFromSelect,
            'beforeShowDayTo': beforeShowDayToSelect,
            'openToAfterSelectingFromDate': true,
            currentText: options.datepickerOptions.currentText,
            'onCloseTo': refreshCalculation,
            deleteButton: {
                text: options.datepickerOptions.deleteText,
            },
        }
    );

    $('#R_i_from_visual').on('change', function(e) {
        intervalChange(true);
    });

    $('#R_i_to_visual').on('change', intervalChange);
    var falseSync = canUseSyncXHR ? false : true;
    $("select[id$=_selected]").on('change', function() {
        var unitId = $(this).val();

        if (typeof unavailDates[unitId] === 'undefined') {
            window.requestList.pReservation = $.ajax({
                type: "POST",
                url: getUnavailDatesUrlJSON,
                dataType: "json",
                data: { 'unit_id': unitId },
                async: falseSync,
                success: function(response) {
                    unavailDates[unitId] = response.unavail_dates[unitId];
                    refreshPersonNumber();
                }
            });
        } else {
            refreshPersonNumber();
        }

    });
    $('#R_g_type').on('change', guestTypeChange);

    $('#R').on('click', '.addUnit', function() {
        addUnit();
    });

    $('#R').on('click', '.deleteUnit', function() {
        removeUnit($(this));
    });

    guestTypeChange();
    $("input[id^=R_recomm_type_]").on('change', function () {
        $("input[id^=R_recomm_type_]").each(function () {
            $(this).parents('.formInputHolderPay').find(".formInputInner input").toggle($(this).prop('checked'));
        });
    }).change();

    $('#R_pet').change(function () {
        $('.petDescription').toggle($(this).val() > 0);
        if ($(this).val() == 0) {
            $("#R_pet_desc").val('');
        }
    }).change();

    $('#refreshCalculation').on('click', refreshCalculation);
    $(triggerCalculation).on('change', refreshCalculation);
    $('#R_pet_desc').on('keyup', function () {delayKeyUp(refreshCalculation, 1500);});

    $("select[id^=R_p_age]").on('change', function () {delayKeyUp(refreshCalculation, 600);});
    $(triggerCalculationKeyUp).on('keyup', function () {delayKeyUp(refreshCalculation, 600);});

    $('#R_insurance').on('change', function () {
        var insuranceTypeRowSelector = $('.insuranceTypeRow');

        if ($(this).prop('checked')) {
            insuranceTypeRowSelector.slideDown(fadeInAndOutTime);
            userSelectedBookingInsuranceOption = true;
        } else {
            insuranceTypeRowSelector.slideUp(fadeInAndOutTime);
            userSelectedBookingInsuranceOption = false;
            $("input[id^=R_insurance_type_]").each(function () {
                $(this).prop("checked",false);
            });
        }

        refreshCalculation();
    });

    $('#R_remarks').on('change', () => reportUnfinishedReservation());

    $('#R_weather_insurance').on('change', function () {
        userSelectedWeatherInsurance = true;
        if ($(this).prop('checked')) {
            userSelectedWeatherInsuranceValue = true;
            $(this).toggle($(this).prop('checked'));
            $('#weather_insurance').slideDown(fadeInAndOutTime);
        } else {
            userSelectedWeatherInsuranceValue = false;
            $('#weather_insurance').slideUp(fadeInAndOutTime);
        }
    });

    $('#R_transfer').on('change', function () {

        var transferSelectionHolder = $("#transferSelectionHolder");

        if ($(this).prop('checked')) {
            transferSelectionHolder.slideDown(fadeInAndOutTime);
        } else {
            transferSelectionHolder.slideUp(fadeInAndOutTime);
        }
    });

    if (isInline) {
        $('.termsAndConditions').css('display', 'none');
        $('.userNewsletterAndConsent').css('display', 'none');
    }

    refreshCalculation(true, true);
    // Svakih 20 minuta (1200000 ms) se napravi refresh kalkulacije kako ne bi istekla sesija
    window.intervalCalculationID = setInterval(refreshCalculation, 1200000);

    $("#R").on('click', '.nextStep', function (e) {
        e.preventDefault();

        var button = $(this);
        button.blur();

        if (!$(this).hasClass('gray')) {
            if (step == 1) {
                changeStep(2, true);
            } else if (step == 3) {
                var $previousStepLink = $('.previousStep');

                if (preventDoubleSubmit) {
                    return;
                } else {
                    preventDoubleSubmit = true;
                }

                button.removeClass('green').addClass('gray');
                $previousStepLink.css('display', 'none');
                $('#reservationLoaderFull').fadeIn(fadeInAndOutTime);

                var postData = $('#R').serialize();
                window.requestList.pReservation = $.ajax({url:reservationUrl, type:'POST', data:postData, cache:false,
                    success: function (response) {
                        if (response.status == 'error') {
                            $previousStepLink.css('display', 'inline-block');
                            button.removeClass('gray').addClass('green');
                            preventDoubleSubmit = false;
                            createErrorMessagesList(response.errors);
                            $('#reservationLoaderFull').fadeOut(fadeInAndOutTime);
                        } else {
                            if (response.link) {
                                $.get(response.link, function(data){
                                    $('#reservationLoaderFull').fadeOut(fadeInAndOutTime);
                                    $('.reservationCalculation').hide();
                                    $('#reservationFormHolder').html(data);
                                });
                            } else {
                                button.removeClass('gray').addClass('green');
                                preventDoubleSubmit = false;
                            }
                        }
                    }
                });

                $('.termsAndConditions').show();
                // sakrij Newsletter i Consent checkboxe na 4. koraku
                $('.userNewsletterAndConsent').hide();
                // sakrij link detaljne kalkulacije na 4. koraku
                $('.calculationDetails').hide();
            } else {
                changeStep(parseInt($(this).data('nextstep'), 10), true);
            }
        }
    });

    $('.calculationDetails').prettyPhoto({
        custom_markup: '<div id="calculationTableContainer"><div class="loader32w" style="display:block"></div></div>',
        social_tools: '',
        allow_resize: false,
        changepicturecallback: () => {
            const postData = $('#R').serialize();
            if (window.local_vac_frame) {
                const topPos = $('.calculationDetails').scrollTop();
                const caclDetailsLink = $('.calculationDetails').offset().top;
                $('.pp_pic_holder').css('top', caclDetailsLink - topPos - 200);
            }
            $.ajax({
                type: 'POST',
                url: calculationUrlTable,
                data: postData,
                success: (response) => {
                    $('.pp_content').css('height', 'auto');
                    $('#calculationTableContainer').html(response);
                },
            });
            $('.pp_pic_holder, .pp_overlay').swipe({ allowPageScroll: 'none' });
        },
    });

    $("select[id$=_selected]").on('change', function () {
        if ($(this).val().length == 0 && $('.unitRow').length - $('.unitRow.unitHidden').length > 1) {
            $(this).parents('.unitRow').addClass('unitHidden');
            $(this).parents('.unitRow').find('.personsNumbersWrap').hide();
        } else {
            var unitId = $(this).val();
            var unitPersonsSelects = $(this).parents('.unitRow').find('.personsSelect');

            if (unitsCapacity[unitId]) {
                editUnitPersonsSelectors(unitPersonsSelects, unitsCapacity[unitId]);
            }

            $(this).parents('.unitRow').find('.personsNumbersWrap').show();
        }
    });

    $(".reservationForm a[rel=lightbox]").prettyPhoto(prettyPhotoOptions);

    if ($("#bookingSubmitButton")) {
        $("#R").on('click', '#bookingSubmitButton', function (e) {

            if (!isInline) {
                if (registerUser(false)) {
                    if (refreshCalculation(false)) {
                        $("R").submit();
                    } else {
                        e.preventDefault();
                    }
                } else {
                    e.preventDefault();
                }
            }
        });
    }

    if (!step) {
        var tmpWindow = $(window),
            tmpSWrapper = $('#serviceWrapper'),
            calcOffsetBottom,
            sideCalculation = $('#sideCalculation'),
            calcOffsetTop = sideCalculation.offset().top - 20;

        tmpWindow.scroll(function () {
            calcOffsetBottom = tmpSWrapper.height() - sideCalculation.height();

            if (tmpWindow.scrollTop() < calcOffsetTop) {
                sideCalculation.removeClass('fixedCalculation bottomCalculation');
            } else if (tmpWindow.scrollTop() > calcOffsetBottom) {
                sideCalculation.removeClass('fixedCalculation').addClass('bottomCalculation');
            } else {
                sideCalculation.removeClass('bottomCalculation').addClass('fixedCalculation');
            }
        });
    }

    refreshPersonNumber();
}

function changeStep(nextStep, skipRefreshCalculation) {
    // GA eventovi - https://home/projects/planning/wiki/Google_Analytics_eventi
    var isLastStep = nextStep == 4;

    if (isInline && !isSubagent && !isLastStep) {
        var isForward = step < nextStep;
        var isBackwards = nextStep < step;
        var totalPrice = $('#totalPrice').data('rawprice') || 0;

        if (isForward) {
            setGaqPush('Inline forma', nextStep + '. korak', privateObjectId, totalPrice);
        } else if (isBackwards) {
            setGaqPush('Inline forma', step + '. korak (natrag)', privateObjectId, totalPrice);
        }
    }

    $('[data-nextstep=2]').css('display', 1 == nextStep ? '' : 'none');
    $('.previousStep').css('display', 1 == nextStep ? 'none' : 'inline-block');
    $('.totalPriceWrap, .paymentIcons, .calculationDetails').css('display', 2 != nextStep ? '' : 'none');

    if (nextStep == 3) {
        $('.termsAndConditions').show();
        $('.userNewsletterAndConsent').show();

        $.post(userAgreementsStatusUrl, {email: $("#R_user_register_email").val()} ).then((response) => {
            var consentBox = $("#consent_checkbox");
            var newsletterBox = $(".newsletterCheckbox");

            response.consentStatus ? consentBox.hide() : consentBox.show();
            response.newsletterStatus ? newsletterBox.hide() : newsletterBox.show();
        });
    } else {
        $('.termsAndConditions').hide();
        $('.userNewsletterAndConsent').hide();
    }

    $('.reservationStep').each(function() {
        var $self = $(this);
        $self.toggleClass('active', nextStep == $self.data('reservation-step'));
    });

    if (nextStep == 2) {
        $('.reservationUser').hide();
    } else {
        $('.reservationUser').show();
    }

    if (isOurSiteUser && nextStep == 2) {
        initiateConversionEvents();
    }

    if (nextStep == 2 || nextStep == 3) {
        $('.reservationCalculation').show();
    } else {
        $('.reservationCalculation').hide();
    }

    if (nextStep === 1 && $('.unitHidden').length > 0) {
        $('#addUnitBtn').show();
    } else {
        $('#addUnitBtn').hide();
    }
    if (nextStep == 3 && isUserSubscribedToNewsletter) {
        $('.newsletterCheckbox').hide();
    }

    if (isInline) {
        for (var i = 1; i <= 3; i++) {
            $("[data-step=" + i + "]").toggle(i == nextStep);
        }
    }

    if (nextStep > stepMax) {
        stepMax = nextStep;
    }

    var errorList = $('.calculationMessages');
    if (errorList.length > 0) {
        errorList.empty();
    }

    if ($('.subagentPhone').length < 1) {
        if (nextStep == 2 && ( isUserSignedIn || ($('#reservationUserInfo').length > 0 && $('#reservationUserInfo').css('display') == 'block'))) {
            $("[data-nextstep=3]").show();
        } else {
            $("[data-nextstep=3]").hide();
        }
    }

    step = nextStep;

    if (skipRefreshCalculation === undefined) {
        refreshCalculation();
    }

    $(".reservationForm a[rel=lightbox]").prettyPhoto(prettyPhotoOptions);
}

function changeStepForSocialLogin(profileModified,apiLoginTime) {
    var timeNow = Math.round(new Date().getTime() / 1000);

    if (isUserAuthenticated && (timeNow - apiLoginTime) < 10) {
        changeStep(2, true);
    }
}

function createErrorMessagesList(errors) {
    var list = $('<ul />');
    $.each(errors, function(id, value){
        if (value instanceof Array) {
            $.each(value, function(key, val){
                list.append($('<li />').html(val));
            });
        } else {
            list.append($('<li />').html(value));
        }
    });
    $('.calculationMessages').each(function () {
        $(this).html(list.html());
    });
}

// singleUser.js begin
function showUserInfo(response, userInfo) {
    if (userInfo) {
        if ($('#reservationUserInfo').length < 1) {
            $('#reservationUser').prepend($('<div id="reservationUserInfo">'));
        }
    }

    $('#userSignInSignOut').html(response.data.userSignInSignOut).show();

    if (userInfo) {
        $('#reservationUserInfo').html(response.data.userInfo).show();
        $('#reservationUserType, #reservationLogin, #reservationRegister').hide();
    } else {
        $('#reservationRegister').show();
    }

    if (isUserSignedIn) {
        $('#reservationUserType').hide();
    }

    $('#userNotAuthenticated').hide();

    if (!isUserSubscribedToNewsletter) {
        $('.formInputHolderReg newsleterCheck').hide()
    }

    if (typeof service === 'undefined' || service == "private") {
        // do nothing
    } else if (service == "charter" || service == "lighthouse") {
        // globalna varijabla samo u čarter i lighthouse uslugama, ne postoji za private
        preCheck();
    }
}

function fillRegisteredUserData(r_user, email = null) {
    $('#R_user_register_title').val(r_user.title);
    $('#R_user_register_first_name').val(r_user.first_name);
    $('#R_user_register_last_name').val(r_user.last_name);
    $('#R_user_register_country').val(r_user.country);
    $('#R_user_register_phone_type').val(r_user.phone_type);
    $('#R_user_register_phone_number').val(r_user.phone_number);
    if (null !== email) {
        $('#R_user_register_email').val(email);
    } else {
        $('#R_user_register_email').val(r_user.email);
    }

    if (!isUserSubscribedToNewsletter) {
        $('formInputHolderReg, .newsleterCheck').hide();
    }

    if (r_user.newsletter == 0) {
        $('#R_user_register_newsletter').prop('checked', false);
    } else {
        $('#R_user_register_newsletter').prop('checked', true);
    }
}

function refreshLogin() {
    $('#userInlineResLoader').fadeIn(fadeInAndOutTime);
    $('#reservationUserWrap').find('input').blur();

    const loginData = {
        'username' : $('input[id$=_user_login_username]').val(),
        'password' : $('input[id$=_user_login_password]').val()
    };

    window.requestList.pReservation = $.ajax({
        type: 'POST',
        url:userInfoUrl,
        data:loginData,
        success:function (response) {
            if (response.status == 'success') {
                isUserSignedIn = true;

                if (!isInline) {
                    $("#registerButtonBlock").hide();
                } else {
                    $("#registerButtonBlock").show();
                }

                if (response.data.hasUserConsent) {
                    $('#consent_checkbox').hide();
                }

                if (response.data.isUserSubscribedToNewsletter) {
                    $('.newsletterCheckbox').hide();
                }

                refreshSignOnSignOff(response);
                if (response.data.r_user !== undefined) {
                    removeRegistrationErrors();
                    fillRegisteredUserData(response.data.r_user);
                } else {
                    changeStep(3);
                }
            } else {
                $('#reservationUserInfo').empty().hide();
                $('#reservationUserType, #reservationLogin').show();
                $('#reservationRegister').hide();

                var errorList = $('#reservationLogin ul.validationMessage');

                if (errorList.length) {
                    errorList.empty();
                } else {
                    $('#reservationLogin').prepend($('<ul class="validationMessage" />'));
                }

                $.each(response.data, function(field, error){
                    $('#reservationLogin ul.validationMessage').append('<li>'+error+'</li>');
                });

                $('#userNotAuthenticated').show();
            }
            $('#userInlineResLoader').fadeOut(fadeInAndOutTime);
        }
    });
}

function registerUser(subagent) {
    $('#userInlineResLoader').fadeIn(fadeInAndOutTime);
    $('#reservationUserWrap').find('input').blur();

    var postData = {};
    //  var recommendationData = {};

    var formName = subagent ? 'user_subagent_register' : 'user_register';
    var newsletterChecked = $('#R_user_register_newsletter').is(":checked");

    $('[name*="['+formName+']"]').each(function () {
        var name = '[' + $(this).attr('name').replace(/^[a-zA-Z]+\[/, '');

        name = name.replace('['+formName+'][', '').replace(/]/gi, '');

        if (name.indexOf('phone') === 0 && !subagent) {
            if (postData.phone === undefined) {
                postData['phone'] = {};
            }

            postData['phone'][name.replace('phone[', '')] = $(this).val();
        } else {
            // U slucaju kada newsletter nije chekiran ne smijemo ga slat na server zato sto ce ga se onda renderirati i oznaciti kao da je chekiran
            // Checkbox se nikada ne salje na server u nikakvom requestu ako nije chekiran
            if ('newsletter' !== name) {
                postData[name] = $(this).val();
            }
        }
    });

    if (!subagent) {
        if (newsletterChecked) {
            postData['newsletter'] = 1;
        }
        //recommendationData['recommending_code'] = $('[name*="[recommendation][recommending_code]"]').val();
    }
    var isUserRegistered = false;
    var registerAction = subagent ? subagentUserRegisterUrl : userRegisterUrl;
    var isSyncInline = canUseSyncXHR ? isInline : true;

    window.requestList.pReservation = $.ajax({
        type: 'POST',
        async: isSyncInline,
        url: registerAction,
        data: {"registration":postData },
        success: function (response) {
            removeRegistrationErrors();

            if (response.status == 'success') {
                isUserRegistered = true;

                if (response.hasConsent) {
                   doesUserHaveConsent = true;
                }

                if (response.isSubscribedToNewsletter) {
                    isUserSubscribedToNewsletter = true;
                }

                if (subagent) {
                    if (isInline) {
                        changeStep(3);
                    }
                } else {
                    isUserSignedIn = true;
                    if ( typeof response.data.userRegisterPartial !== "undefined" ) {
                        $('#reservationRegister').html(response.data.userRegisterPartial);
                    }

                    refreshSignOnSignOff(response);
                    showUserInfo(response, false);
                    if (isInline) {
                        changeStep(3);
                    }
                }
            } else {
                var errorList;
                if (subagent) {
                    errorList = $('#reservationRegister ul.validationMessage');
                    if (errorList.length > 0) {
                        errorList.empty();
                    } else {
                        $('#reservationRegister').append($('<ul class="validationMessage" />'));
                    }

                    $.each(response.data, function(field, error){
                        $('#reservationRegister ul.validationMessage').append('<li>'+error+'</li>');
                    });
                } else {
                    if (response.data.userRegisterPartial) {
                        $('#reservationRegister').html(response.data.userRegisterPartial);
                    }

                    errorList = $('#reservationRegister ul.validationMessage');
                    if (errorList.length > 0) {
                        errorList.empty();
                    } else {
                        $('#reservationRegister').append($('<ul class="validationMessage" />'));
                    }

                    if (response.data.user_error) {
                        $('#reservationRegister ul.validationMessage').append('<li>'+response.data.user_error+'</li>');
                    }
                }
            }
            $('#userInlineResLoader').fadeOut(fadeInAndOutTime);
        }
    });
    return isUserRegistered;
}

function changeUserType(element) {
    if (element.val() == 'new') {
        $('#reservationLogin').hide();
        $('#reservationRegister').fadeIn(fadeInAndOutTime);
    } else {
        $('#reservationUserLogin').show();
        $('#reservationLogin').fadeIn(fadeInAndOutTime);
        $('#reservationRegister').hide();
    }
}

// parse a date in yyyy-mm-dd format
function parseDate(input) {
    var parts = input.match(/(\d+)/g);
    // new Date(year, month [, date [, hours[, minutes[, seconds[, ms]]]]])
    return new Date(parts[0], parts[1]-1, parts[2]); // months are 0-based
}

function reservationAfterLoad() {
    $("#R").on("click", "#loginButton, #userDataRefresh", function() {
        refreshLogin();
    });

    $("#R").on("click", "#registerButton", function() {
        registerUser(false);
    });

    $("#R").on("change", "input[id*=_u_type]", function() {
        changeUserType($(this));
    });

    // IE 8 fix & backward compatibility
    var ValObj = new Object();
    ValObj.val = function () {
        return (isSubagent) ? ('new') : ('existing');
    };
    var adrDefaultUserType = ($("input[id*=_u_type]:checked").length > 0 ) ? ($("input[id*=_u_type]:checked")) : (ValObj);
    changeUserType(adrDefaultUserType); // $("input[id*=_u_type]:checked").length > 0 - IE 8 problem

    $('#reservationRegister').keypress(function(e){
        if (e.which == 13 && $('.subagentPhone').length < 1) {
            e.preventDefault();
            registerUser(false);
        }
    });

    $(".registerSubagentUser").on('click', function(e){
        e.preventDefault();
        registerUser(true);
    });

    $('#reservationLogin').keypress(function(e){
        if (e.which == 13) {
            e.preventDefault();
            refreshLogin();
        }
    });
}
// singleUser.js end

// updateUserProfile.js begin
function updateUserProfileData() {
    $('#userInlineResLoader').fadeIn(fadeInAndOutTime);
    $('#reservationUserWrap').find('input').blur();

    var profileUpdatePostData = {};
    var profileUpdateFormName = 'user_update_profile';
    var newsletterCheckbox = $('#R_user_update_profile_newsletter');

    $('[name*="['+profileUpdateFormName+']"]').each(function () {
        var name = '[' + $(this).attr('name').replace(/^[a-zA-Z]+\[/, '');
        name = name.replace('['+profileUpdateFormName+'][', '').replace(/]/gi, '');

        if (name.indexOf('phone') === 0) {
            if (profileUpdatePostData.phone === undefined) {
                profileUpdatePostData['phone'] = {};
            }

            profileUpdatePostData['phone'][name.replace('phone[', '')] = $(this).val();
        } else {
            profileUpdatePostData[name] = $(this).val();
        }
    });

    if (newsletterCheckbox.is(":checked")) {
        profileUpdatePostData.newsletter = 1;
    } else {
        profileUpdatePostData.newsletter = 0;
    }

    $.post(userUpdateProfileUrl, {'sfApplySettings' : profileUpdatePostData}, function(response){
        if (response.status == 'success') {
            changeStep(3);
        } else {
            $('#reservationUpdateProfile').html(response.data);
            $('#userInlineResLoader').fadeOut(fadeInAndOutTime);
        }
    });
}

$("#R").on('click', '#updateProfileData', function () { updateUserProfileData(); });
$("#R").on('change', '#R_user_update_profile_country', function () { changeCountry(); });

// updateUserProfile.js end

// phoneSingle start

function getPhoneContainer(element) {
    return element.parents('.phoneContainer');
}

function getNumberField(element) {
    if (getPhoneContainer(element).find('input[id$=_phone_number]').length > 0) {
        return getPhoneContainer(element).find('input[id$=_phone_number]');
    } else {
        return getPhoneContainer(element).find('input[id$=_phone]');
    }
}

function getPhoneType(element) {
    var phoneType = getPhoneContainer(element).find('select[id$=_phone_type]');

    if (phoneType.length > 0) {
        return phoneType.val();
    }

    return false;
}

function getCountryCode() {
    var countrySelect = $('select[id$=_country]');
    var countryCode;

    if (countrySelect.length > 0 && countrySelect.val()) {
        countryCode = countrySelect.find('option:selected').data('phone-code');
    }

    if (!countryCode) {
        countryCode = '385';
    }

    return countryCode;
}

function changeCountry() {
    if ($('input[id$=_phone_number]').length > 0) {
        $('input[id$=_phone_number]').each(function () {
            if ($(this).val().length < 5) {
                changePhoneType($(this), true);
            }
        });
    }

    if ($('input[id$=_phone]').length > 0) {
        $('input[id$=_phone]').each(function () {
            if ($(this).val().length < 5) {
                changePhoneType($(this), true);
            }
        });
    }
}

function changePhoneType(element, changeNumber) {
    var countryCode = getCountryCode();

    if (getPhoneType(element) != 3 && countryCode == '39') {
        countryCode = '390';
    }

    if (changeNumber) {
        getNumberField(element).val('+' + countryCode);
    }
}

function fixNumber(element) {
    var numberField = getNumberField(element);
    var number = numberField.val().replace(/[^0-9x]/g, '');
    var numberType = getPhoneType(element);

    while(number.substr(0, 1) == '0') {
        // uklanja početne nule jer nisu dozvoljene
        number = number.substr(1);
    }

    numberField.val('+' + number);
}

$("#R").on('keyup', 'input[id$=_phone_number]', function () { fixNumber($(this)); });
$("#R").on('keyup', 'input[id$=_phone]', function () { fixNumber($(this)); });
$("#R").on('change', 'select[id$=_country]', function () { changeCountry(); });
$("#R").on('change', 'select[id$=_phone_type]', function () { changePhoneType($(this), false); });

if ($('input[id$=_phone_number]').length > 0 && $('input[id$=_phone_number]').val() == '') {
    $('select[id$=_country]').trigger('change');
}

if ($('input[id$=_phone]').length > 0 && $('input[id$=_phone]').val() == '') {
    $('select[id$=_country]').trigger('change');
}

changeCountry();
//phoneSingle end
function removeRegistrationErrors() {
    $('#reservationRegister .validationMessage').remove();

    $('#reservationRegister input, #reservationRegister select')
        .parentsUntil('#reservationRegister')
        .removeClass('rowError');
}

function refreshSignOnSignOff(response) {
    if ($('#reservationUserInfo').length < 1) {
        $('#reservationUser').prepend($('<div id="reservationUserInfo">'));
    }

    if (!isUserSubscribedToNewsletter) {
        $('formInputHolderReg, .newsleterCheck').hide();
    }

    if (doesUserHaveConsent) {
        $('#consent_checkbox').hide();
    }

    $('#userSignInSignOut').html(response.data.userSignInSignOut).show();
    $('#reservationRegister').fadeIn(fadeInAndOutTime);
    $('#reservationUserType, #reservationLogin').hide();
}

$("#userNotAuthenticated").on('click', function(e) {
    e.preventDefault();
    $('#reservationUserLogin').show();
    $('#reservationLogin').show();
    $('#reservationRegister').hide();
    $("#userNotAuthenticated").hide();
});

/* Sprema nedovršenu rezervaciju ako su svi uvjeti ispunjeni:
    - gost je logiran
    - gost je na našem siteu (partneri ne dolaze u obzir)
    - gost nije došao preko linka za nedovršenu rezervaciju
    Potrebno je imati na umu da je moguće posjetiti i standalone formu, npr. 'hr/reservation/private?object=1005'.
    U tom slučaju koraci ne postoje pa je potrebno provjeriti da li su uneseni obavezni parametri(termin i broj osoba).
*/
function reportUnfinishedReservation() {
    const from = $('#R_i_from_visual').val();
    const to = $('#R_i_to_visual').val();
    let adultPersonsSet = false;
    $('select[id$="_a1"]').each(function checkSelectedAdultPersons() {
        // ukoliko je odabrano više jedinica, barem jedna jedinica mora sadržavati odrasle osobe
        if ($(this).val() !== 0) {
            adultPersonsSet = true;
        }
    });

    if (!isInline && (adultPersonsSet !== true || from === '' || to === '')) {
        // ukoliko forma nije inline te nisu postavljeni obavezni parametri
        return;
    }
    if (isInline && step < 3) {
        // ukoliko forma jest inline, a nije treći korak rezervacije, ne spremamo nedovršenu rezervaciju
        return;
    }
    if (isUserSignedIn && isOurSiteUser && isUnfinishedReservation === false) {
        const postData = $('#R').serialize();
        if (postData !== '') {
            $.post(unfinishedReservationUrlJSON, postData);
        }
    }
}

/**
 * Aktivira eventove za Google Analytics.
 */
function initiateConversionEvents() {
    Ad.GAdimensions.sendHrental(
        privateObjectId.toString(),
        'conversionintent',
        $('#totalPrice').data('rawprice').toString(),
        $('#R_i_from').val(),
        $('#R_i_to').val()
    );
}

/**
 * @param {Object} calculationResponse - HTTP odgovor zahtjeva za kalkulacijom
 * @param {bool} initialCalculation - Je li ovo inicijalna kalkulacija, napravljena neposredno nakon (prilikom)
 * učitavanja stranice?
 */
function updateDataLayerAfterCalculationRefresh(calculationResponse, initialCalculation) {
    // Ako je ukupna cijena poznata odmah prilikom učitavanja stranice (uključujući i asinkrone requestove koji se odmah
    // izvršavaju)
    if (!initialCalculation) {
        return;
    }

    if (typeof calculationResponse.data.total_price_raw === 'undefined') {
        return;
    }

    const units = [];
    const persons = [];
    document.querySelectorAll('select[id^="R_u_"][id$="_selected"]').forEach(function(unitElement, unitIndex) {
        const unit = unitElement.value;
        if (unit === '') {
            return;
        }
        units.push(unit);
        persons.push({
            adults: Number(document.getElementById(`R_u_${unitIndex}_a1`).value),
            children: {
                age0To3: Number(document.getElementById(`R_u_${unitIndex}_c3`).value),
                age4To11: Number(document.getElementById(`R_u_${unitIndex}_c2`).value),
                age12To17: Number(document.getElementById(`R_u_${unitIndex}_c1`).value),
            },
        });
    });

    const dates = {
        checkIn: document.getElementById('R_i_from').value,
        checkOut: document.getElementById('R_i_to').value,
    };

    const price = {
        amount: Math.round(Number(calculationResponse.data.total_price_raw) * 100),
        currency: 'EUR',
    };

    dataLayerRegisterPrivateAccommodationReservationPriceCalculated(units, dates, persons, price);
}

export {
    singleInit,
    reservationAfterLoad,
};
